<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    :title="templateTitle"
    :visible.sync="dialogVisible"
    width="65%"
    :close-on-click-modal="false"
    class="self-dialog-form"
  >
    <el-form
      ref="formEl"
      :model="formData"
      :rules="formRules"
      :disabled="disabledStatus"
      class="demo-formData clearfix"
      label-position="top"
    >
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item :label="$t('parameterTemplate.belongModule')" prop="belongModule">
            <el-input v-model="formData.belongModule"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('parameterTemplate.belongModuleName')" prop="belongModuleName">
            <el-input v-model="formData.belongModuleName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('dictInfo.dictItemInfo.sort')">
            <el-input-number
              v-model="formData.sort"
              :controls="false"
              :min="0"
              :step="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="16">
          <el-form-item :label="$t('common.description')">
            <el-input v-model="formData.remark"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="!disabledStatus" class="pb8 clearfix mb10">
      <el-button
        class="float-right"
        icon="el-icon-circle-plus-outline"
        type="primary"
        @click="handleAdd()"
      >
        {{ $t("common.add") }}
      </el-button>
    </div>
    <EdmCustomTable
      ref="customTable"
      :show-pagination="false"
      :loading="tableLoading"
      :table-data="formData.paramItemList"
      :show-overflow-tooltip="true"
    >
      <el-table-column
        :width="200"
        :label="$t('parameterTemplate.paramsCode')"
        prop="configKey"
      ></el-table-column>
      <el-table-column
        :width="200"
        :label="$t('parameterTemplate.paramsName')"
        prop="configName"
      ></el-table-column>
      <el-table-column
        :width="100"
        :label="$t('parameterTemplate.paramsType')"
        prop="configTypeName"
      ></el-table-column>
      <el-table-column
        width="auto"
        :label="$t('parameterTemplate.paramsMapping')"
        prop="selectContentsName"
      ></el-table-column>
      <el-table-column
        :width="100"
        :label="$t('excelConfiguration.defaultValue')"
        prop="defaultValue"
      ></el-table-column>
      <el-table-column fixed="right" :label="$t('public.operation')" width="130">
        <template slot-scope="scope">
          <el-button
            v-if="!disabledStatus"
            type="text"
            class="btn__text--no-padding"
            @click="handleEdit(scope.row)"
          >
            {{ $t("public.edit") }}
          </el-button>
          <el-button
            type="text"
            class="btn__text--no-padding"
            @click="handleView(scope.row, 'view')"
          >
            {{ $t("public.detail") }}
          </el-button>
          <el-button
            v-if="!disabledStatus"
            type="text"
            class="btn__text--no-padding btn__text--red"
            @click="deleteRowData(scope.$index)"
          >
            {{ $t("public.delete") }}
          </el-button>
        </template>
      </el-table-column>
    </EdmCustomTable>
    <div slot="footer" class="dialog-footer" style="padding-right: 5px">
      <el-button plain @click="dialogVisible = false">{{ $t("public.cancel") }}</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">
        {{ $t("public.save") }}
      </el-button>
    </div>
    <!-- 表格删除确认框 -->
    <delete-dialog
      layout="left"
      :visible.sync="deleteDialogVisible"
      :content="deleteContent"
      :loading.sync="deleteLoading"
      @confirm="handleDeleteConfirm"
    />
    <!-- /表格删除确认框 -->
    <parameter-add
      v-if="dialogFormVisible"
      :visible.sync="dialogFormVisible"
      :prop-data="parameterData"
      :status="dialogFormStatus"
      @confirm="handleUpdateList"
    />
  </el-dialog>
</template>

<script>
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
import ParameterAdd from "./inner-components/add-parameter.vue";
import parameterApi from "@/api/parameter-template";
export default {
  name: "ParameterTemplateAdd",
  components: {
    ParameterAdd,
    DeleteDialog,
  },
  props: {
    visible: Boolean,
    type: String,
    propsData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formKey: new Date().getTime(),
      formData: {
        belongModule: "",
        belongModuleName: "",
        remark: "",
        paramItemList: [],
      },
      formRules: {
        belongModule: [
          {
            required: true,
            message: `${this.$t("public.pleaseEnter")}${this.$t("parameterTemplate.belongModule")}`,
            trigger: "blur",
          },
        ],
        belongModuleName: [
          {
            required: true,
            message: `${this.$t("public.pleaseEnter")}${this.$t(
              "parameterTemplate.belongModuleName"
            )}`,
            trigger: "blur",
          },
        ],
      },
      tableLoading: false,
      deleteDialogVisible: false,
      deleteLoading: false,
      deleteContent: {
        title: this.$t("common.popupDelete.title"),
        description: this.$t("common.popupDelete.description"),
      },
      deleteRows: -1,
      dialogFormVisible: false,
      dialogFormStatus: "",
      parameterData: {},
      loading: false,
    };
  },
  computed: {
    disabledStatus() {
      return this.type === "details";
    },
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    templateTitle() {
      switch (this.type) {
        case "details":
          return this.$t("parameterTemplate.templateDetail");
        case "edit":
          return this.$t("parameterTemplate.editTemplate");
        default:
          return this.$t("parameterTemplate.addTemplate");
      }
    },
  },
  created() {
    if (this.propsData.id) {
      this.getDetails(this.propsData.id);
    }
  },
  methods: {
    // 获取数据源
    getDetails(id) {
      parameterApi.getModuleParamsById({ id }).then((res) => {
        if (res.success) {
          this.$set(this, "formData", res.data);
          const typeObject = {
            "1-1": this.$t("parameterTemplate.stringType"),
            "1-0": this.$t("parameterTemplate.numberType"),
            0: this.$t("parameterTemplate.switchType"),
            2: this.$t("parameterTemplate.singleType"),
            3: this.$t("parameterTemplate.multipleType"),
          };
          (this.formData.paramItemList || []).forEach((item) => {
            if (item.configType === 1) {
              if (item.textType === "number") {
                item.configType = "1-0";
              } else if (item.textType === "text") {
                item.configType = "1-1";
              }
            }
            item.configTypeName = typeObject[item.configType] || "";
            let selectContentsName = "";
            item.selectContents.forEach((o) => {
              selectContentsName += `${o.displayValue}(${o.selectValue});`;
            });
            item.selectContentsName = selectContentsName;
          });
        }
      });
    },
    // 新增
    handleAdd() {
      this.parameterData = {};
      this.dialogFormStatus = "";
      this.dialogFormVisible = true;
    },
    handleEdit(row) {
      this.parameterData = JSON.parse(JSON.stringify(row));
      this.dialogFormStatus = "edit";
      this.dialogFormVisible = true;
    },
    handleView(row, status) {
      this.parameterData = JSON.parse(JSON.stringify(row));
      this.dialogFormStatus = status;
      this.dialogFormVisible = true;
    },
    // 删除
    deleteRowData(index) {
      this.deleteRows = index;
      this.deleteDialogVisible = true;
    },
    // 删除提交
    handleDeleteConfirm() {
      this.formData.paramItemList.splice(this.deleteRows, 1);
      this.deleteDialogVisible = false;
    },
    handleUpdateList(data, status) {
      if (status === "edit") {
        for (let i = 0; i < this.formData.paramItemList.length; i++) {
          const col = this.formData.paramItemList[i];
          if (col.configKey === data.configKey) {
            let selectContentsName = "";
            data.selectContents.forEach((o) => {
              selectContentsName += `${o.displayValue}(${o.selectValue});`;
            });
            this.$set(this.formData.paramItemList, i, {
              ...data,
              selectContentsName,
            });
            break;
          }
        }
      } else {
        if (this.formData.paramItemList.some((col) => col.configKey === data.configKey)) {
          this.$message.warning(this.$t("parameterTemplate.paramsCodeRepeat"));
          return;
        }
        let selectContentsName = "";
        data.selectContents.forEach((o) => {
          selectContentsName += `${o.displayValue}(${o.selectValue});`;
        });
        this.formData.paramItemList.push({
          ...data,
          selectContentsName,
        });
      }
    },
    handleConfirm() {
      this.loading = true;
      this.$refs.formEl.validate((valid) => {
        if (valid) {
          const data = Object.assign({}, this.formData);
          data.paramItemList = data.paramItemList.map((item) => {
            delete item.configTypeName;
            delete item.selectContentsName;
            if (item.configType === "1-1") {
              return {
                ...item,
                configType: 1,
                textType: "text",
              };
            } else if (item.configType === "1-0") {
              return {
                ...item,
                configType: 1,
                textType: "number",
              };
            } else {
              return item;
            }
          });
          if (this.formData.id) {
            parameterApi.editModule(data).then((res) => {
              this.loading = false;
              if (res.success) {
                this.$message.success(this.$t("common.successText"));
                this.dialogVisible = false;
                this.$emit("success");
              }
            });
          } else {
            parameterApi.addModule(data).then((res) => {
              this.loading = false;
              if (res.success) {
                this.$message.success(this.$t("common.successText"));
                this.dialogVisible = false;
                this.$emit("success");
              }
            });
          }
        } else {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mb10 {
  margin-bottom: 10px;
}
</style>
